'use strict';
import angular from 'angular';
import moment from 'moment';

export default class AdminController {
  /*@ngInject*/
  constructor($stateParams, $http, $state, $scope, $location, Borne, toastr) {
    var vm = this;
    vm.data = {};
    vm.electron = window.electron
    vm.config = JSON.parse(fs.readFileSync('./config.json', 'utf-8'));
    exec('osk')
    
    function init () {
      $http.get(vm.config.url + 'api/sites').then(response => {
        if(typeof response.data != 'object') return vm.sites = [];
        vm.sites = response.data;
        if(vm.borne) vm.data.site = vm.sites[_(vm.sites).map('_id').value().indexOf(vm.borne.Site._id)];
        else vm.data.site = vm.sites[0];
        setTimeout(function(){
          $('#sitesSelect').selectpicker('refresh');
          $('#posteSelect').selectpicker('refresh');
        }, 10)
      }).catch(function(err){
        return vm.sites = [];
      });
    }

    Borne.load(vm.config.posteId).then(function () {
      vm.borne = Borne.Poste;
      init();
    })

    vm.validate = function(){
      vm.loading = true;
      fs.writeFile('./config.json', JSON.stringify(vm.config), function(){
        toastr.success('Le fichier de configuration a bien été mis à jour', 'Succés');
        electronProcess.app.relaunch()
        electronProcess.app.exit()
      });
      vm.loading = false;
    }

    vm.quit = function(){
      electronProcess.app.onClosed();
    }

    vm.restart = function(){
      exec('shutdown -t 0 -r -f', (err, stdout, stderr) => {
        console.log(stdout);
        console.log(stderr);
      });
    }

    vm.shutdown = function(){
      exec('shutdown -t 0 -s -f', (err, stdout, stderr) => {
        console.log(stdout);
        console.log(stderr);
      });
    }

    vm.returnToMain = function(){
      $location.path('/borne/' + vm.config.posteId);
    }

  var refreshList = function(nv) {
    init()
  }

  $scope.$watch('vm.config.url', _.throttle(refreshList, 1000))

  $scope.$watch('vm.data.site', function (nv) {
    if(!vm.config.posteId || (vm.data.site &&  !_(vm.data.site.Postes).map('_id').value().includes(vm.config.posteId))) vm.config.posteId = vm.data.site.Postes[0]._id;
    setTimeout(function() {
      $('.selectpicker').selectpicker('refresh');
    }, 10);
  })

  $scope.$watch('vm.config.posteId', function (nv) {
    console.log(nv)
    setTimeout(function() {
      $('.selectpicker').selectpicker('refresh');
    }, 10);
  })


    $('.modal-backdrop').hide()
  }
}


// WEBPACK FOOTER //
// ./client/app/borne/admin/admin.controller.js